module.exports = __webpack_public_path__ + "img/zoom.6cdc03b0.png";